"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_INPUT_PARSER_PASS_THROUGH_FUNCTIONS = exports.ACTION_INPUT_PARSER_BASE_FUNCTIONS = exports.TRIGGER_INPUT_PARSER_FUNCTIONS = exports.TRIGGER_INPUT_FILTER_FUNCTIONS = void 0;
const base_1 = require("./base");
const context_base_1 = require("./context_base");
__exportStar(require("./base"), exports);
__exportStar(require("./context_base"), exports);
exports.TRIGGER_INPUT_FILTER_FUNCTIONS = [
    context_base_1.greaterThan,
    context_base_1.greaterThanOrEqual,
    context_base_1.lessThan,
    context_base_1.lessThanOrEqual,
    context_base_1.equal,
    context_base_1.notEqual,
    context_base_1.isNull,
    context_base_1.isNotNull,
    context_base_1.includes,
    context_base_1.notIncludes,
    base_1.and,
    base_1.or,
];
const makeFunction = (func, funcName) => {
    Object.defineProperty(func, 'name', { writable: false, value: funcName });
    return func;
};
// we must redefine the name of function, otherwise the name will be random after building
// this will be fine in local development, but will cause some strange bugs in production
exports.TRIGGER_INPUT_PARSER_FUNCTIONS = [
    makeFunction(base_1.newObject, 'newObject'),
    makeFunction(base_1.newArray, 'newArray'),
];
// This is for front-end validation
exports.ACTION_INPUT_PARSER_BASE_FUNCTIONS = [
    makeFunction(base_1.and, 'and'),
    makeFunction(base_1.or, 'or'),
    makeFunction(base_1.concatString, 'concatString'),
    makeFunction(base_1.concatParagraph, 'concatParagraph'),
    makeFunction(base_1.newObject, 'newObject'),
    makeFunction(base_1.newArray, 'newArray'),
    makeFunction(base_1.getObjectProperty, 'getObjectProperty'),
    makeFunction(context_base_1.getNodeOutput, 'getNodeOutput'),
];
// It is also used for the front end, without parsing dynamic parameters without knowing the context
exports.ACTION_INPUT_PARSER_PASS_THROUGH_FUNCTIONS = [
    makeFunction(context_base_1.getNodeOutput, 'getNodeOutput')
];
//# sourceMappingURL=index.js.map